module.exports = __webpack_public_path__ + "media/img/illustrations/icons/nav-to-do-bfccbb869629830f1e3aaa70e17085eb.svg";